module.exports = __webpack_public_path__ + "static/img/photo_biaoshi.31b740d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/photo/photo_biaoshi.png
// module id = FvCI
// module chunks = 12